<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">
  <div class="mx-auto flex flex-col place-items-center">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'welcome.header' | translate}}</div>

    <div class="flex mt-10">

      <div id="navigate-to-login" class="bg-white mr-8 cursor-pointer" (click)="onNavigateToLogin()">
        <div class="flex flex-col ml-6 mt-7 mr-6 mb-8 w-80">

          <div class="tk-i-welcome-monkey"></div>

          <div class="flex mt-4">
            <span class="text-sm font-semibold">{{'welcome.left-message-header' | translate}}</span>
          </div>

          <div class="text-xs tk-c-gray mt-4">{{'welcome.left-message-content' | translate}}</div>

        </div>
      </div>

      <div id="navigate-to-create-account" class="bg-white cursor-pointer" (click)="onNavigateToCreateAccount()">
        <div class="flex flex-col ml-6 mt-7 mr-6 mb-8 w-80">

          <div class="tk-i-welcome-create"></div>

          <div class="text-sm font-semibold mt-4">{{'welcome.right-message-header' | translate}}</div>
          <div class="text-xs tk-c-gray mt-4">{{'welcome.right-message-content' | translate}}</div>

        </div>
      </div>

    </div>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>
</div>
